import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import { IPasswordComplexity } from '@models';

@Component({
    selector: 'ui-password-indicator',
    templateUrl: './ui-password-indicator.component.html',
    styleUrls: ['./ui-password-indicator.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiPasswordIndicatorComponent {
    @Input()
    public state?: Partial<IPasswordComplexity>;
    @Input()
    public passwordComplexity!: IPasswordComplexity;

    constructor() { }

    public get enabledRules() {
        return [
            'length',
            'hasLowerCase',
            'hasUpperCase',
            'hasDigits',
            'hasSpecialCharacter',
        ].filter(stringKey => {
            const key = stringKey as keyof IPasswordComplexity;
            return this.passwordComplexity[key];
        });
    }

    public get percent(): number {
        if (!this.state) { return 100; }

        // give 10% for each extra rule
        // length is always there and we remove it from "extras"
        const extraRulesLength = this.enabledRules.length * 10 - 10;

        const passwordRatio = this.state.length != null ? this.state.length / this.passwordComplexity.length : 1;
        const passwordLength = Math.min(1, passwordRatio) * (100 - extraRulesLength);
        const validRulesLength = this.enabledRules.reduce(
            (prev, ruleKey) => {
                const key = ruleKey as keyof IPasswordComplexity;
                return !this.state![key] && key !== 'length' ? prev + 10 : prev;
            },
            0,
        );

        return passwordLength + validRulesLength;
    }
}
